/**
 * Row: fila de lista con title + sub a la izquierda y amount a la
 * derecha (variantes según el estado del movimiento).
 *
 * Sprint 11 v2 S11-V2-06. Replica `.cb-row` del handoff
 * (`docs/COMPONENTES.md § Row`).
 *
 * Variantes del amount:
 * - `in` (verde, ej: pago aplicado).
 * - `out` (naranja-warning, ej: cuota pendiente).
 * - `overdue` (rojo, ej: cuota vencida).
 */
import type { ReactNode } from 'react';

type AmountVariant = 'in' | 'out' | 'overdue';

interface RowProps {
  title: ReactNode;
  sub?: ReactNode;
  amount: ReactNode;
  amountVariant?: AmountVariant;
}

const AMOUNT_CLASSES: Record<AmountVariant, string> = {
  in: 'text-state-success',
  out: 'text-state-warning',
  overdue: 'text-state-danger',
};

export function Row({ title, sub, amount, amountVariant = 'out' }: RowProps) {
  return (
    <div className="flex justify-between items-center text-base">
      <div className="flex flex-col gap-[2px]">
        <span className="text-text-primary">{title}</span>
        {sub && <span className="text-sm text-text-muted">{sub}</span>}
      </div>
      <span className={`font-medium ${AMOUNT_CLASSES[amountVariant]}`}>
        {amount}
      </span>
    </div>
  );
}
